"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledContent = exports.StyledLink = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _icon = _interopRequireDefault(require("../icon/icon.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledLink = _styledComponents.default.span`
  ${({
  isSkipLink,
  theme,
  iconAlign,
  hasContent,
  disabled
}) => (0, _styledComponents.css)`
    display: inline-block;

    ${isSkipLink && (0, _styledComponents.css)`
      a {
        position: absolute;
        padding-left: 24px;
        padding-right: 24px;
        line-height: 36px;
        left: -999em;
        z-index: ${theme.zIndex.aboveAll};
        box-shadow: inset 0 0 0 2px ${theme.colors.primary};
        border: 2px solid ${theme.colors.white};
      }

      a:focus {
        top: 8px;
        left: 8px;
      }
    `}

    a,
  button {
      font-size: ${isSkipLink ? "16px" : "14px"};
      text-decoration: underline;
      color: ${isSkipLink ? theme.text.color : theme.colors.primary};
      display: inline-block;
      ${_icon.default} {
        position: relative;
        vertical-align: middle;
        ${iconAlign === "left" && (0, _styledComponents.css)`
          margin-right: ${hasContent ? "5px" : 0};
        `}
        ${iconAlign === "right" && (0, _styledComponents.css)`
          margin-right: 0;
          margin-left: ${hasContent ? "5px" : 0};
        `}
      }

      &:hover {
        cursor: pointer;
        color: ${isSkipLink ? theme.text.color : theme.colors.secondary};
      }

      &:focus {
        color: ${theme.text.color};
        background-color: ${isSkipLink ? theme.colors.white : theme.colors.focusedLinkBackground};
        outline: none;
      }

      ${disabled && (0, _styledComponents.css)`
        color: ${theme.disabled.text};
        &:hover,
        &:focus {
          cursor: not-allowed;
          color: ${theme.disabled.text};
        }
      `}
    }

    button {
      background-color: transparent;
      border: none;
      padding: 0;
    }
  `}
`;
exports.StyledLink = StyledLink;
StyledLink.defaultProps = {
  theme: _base.default,
  disabled: false,
  hasContent: true
};
StyledLink.propTypes = {
  disabled: _propTypes.default.bool,
  hasContent: _propTypes.default.bool
};
const StyledContent = _styledComponents.default.span``;
exports.StyledContent = StyledContent;